/* AYO reviews: full-screen viewer for WhatsApp screenshots (chat wall or stories). */
if (!customElements.get('ayo-reviews')) {
  class AyoReviews extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('[data-ayo-rv-open]'));
      this.viewer = this.querySelector('[data-ayo-rv-viewer]');
      if (!this.viewer || !this.cards.length) return;
      this.img = this.viewer.querySelector('[data-ayo-rv-img]');
      this.pos = this.viewer.querySelector('[data-ayo-rv-pos]');
      this.barsBox = this.viewer.querySelector('[data-ayo-rv-bars]');
      this.stories = this.dataset.style === 'stories';
      this.duration = parseInt(this.dataset.autoplay, 10) || 5000;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.index = -1;

      if (this.barsBox) {
        this.barsBox.innerHTML = this.cards.map(() => '<span><i></i></span>').join('');
        this.bars = Array.from(this.barsBox.querySelectorAll('i'));
      }
      this.onKey = this.onKey.bind(this);
      this.cards.forEach((c, i) => c.addEventListener('click', () => this.open(i, c)));
      this.viewer.querySelectorAll('[data-ayo-rv-close]').forEach((b) => b.addEventListener('click', () => this.close()));
      this.viewer.querySelectorAll('[data-ayo-rv-prev]').forEach((b) => b.addEventListener('click', () => this.step(-1)));
      this.viewer.querySelectorAll('[data-ayo-rv-next]').forEach((b) => b.addEventListener('click', () => this.step(1)));
      this.viewer.addEventListener('click', (e) => { if (e.target === this.viewer) this.close(); });

      // swipe left/right to change, down to close
      const stage = this.viewer.querySelector('[data-ayo-rv-stage]');
      let x0 = null; let y0 = null;
      stage.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; this.hold = true; }, { passive: true });
      stage.addEventListener('touchend', (e) => {
        this.hold = false;
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0; const dy = e.changedTouches[0].clientY - y0;
        x0 = null;
        if (dy > 90 && Math.abs(dy) > Math.abs(dx)) { this.close(); return; }
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
          const rtl = getComputedStyle(this).direction === 'rtl';
          this.step((dx < 0) !== rtl ? 1 : -1);
        }
      }, { passive: true });
    }

    disconnectedCallback() {
      this.stopTimer();
      document.removeEventListener('keydown', this.onKey);
      document.documentElement.classList.remove('ayo-lock');
    }

    open(i, trigger) {
      this.trigger = trigger || document.activeElement;
      this.viewer.hidden = false;
      requestAnimationFrame(() => this.viewer.classList.add('is-open'));
      document.documentElement.classList.add('ayo-lock');
      document.addEventListener('keydown', this.onKey);
      this.show(i);
      const close = this.viewer.querySelector('[data-ayo-rv-close]');
      if (typeof trapFocus === 'function') trapFocus(this.viewer, close);
      else if (close) close.focus();
    }

    close() {
      if (this.viewer.hidden) return;
      this.stopTimer();
      this.viewer.classList.remove('is-open');
      document.documentElement.classList.remove('ayo-lock');
      document.removeEventListener('keydown', this.onKey);
      setTimeout(() => { if (!this.viewer.classList.contains('is-open')) { this.viewer.hidden = true; this.img.removeAttribute('src'); } }, 250);
      if (typeof removeTrapFocus === 'function') removeTrapFocus(this.trigger && this.trigger.isConnected ? this.trigger : null);
      else if (this.trigger) this.trigger.focus();
      this.index = -1;
    }

    step(d) {
      const n = this.cards.length;
      const next = this.index + d;
      if (this.stories && next >= n) { this.close(); return; }
      this.show(((next % n) + n) % n);
    }

    show(i) {
      this.index = i;
      const card = this.cards[i];
      this.img.src = card.dataset.full;
      this.pos.textContent = `${i + 1} / ${this.cards.length}`;
      card.classList.add('is-seen');
      if (this.stories) this.startTimer();
    }

    startTimer() {
      this.stopTimer();
      if (!this.bars) return;
      this.bars.forEach((b, k) => { b.style.width = k < this.index ? '100%' : '0%'; });
      if (this.reduced) { this.bars[this.index].style.width = '100%'; return; }
      const bar = this.bars[this.index];
      let t = 0;
      this.timer = setInterval(() => {
        if (this.hold || document.hidden) return;
        t += 100;
        bar.style.width = `${Math.min(100, (t / this.duration) * 100)}%`;
        if (t >= this.duration) this.step(1);
      }, 100);
    }

    stopTimer() { clearInterval(this.timer); this.timer = null; }

    onKey(e) {
      if (e.key === 'Escape') this.close();
      const rtl = getComputedStyle(this).direction === 'rtl';
      if (e.key === 'ArrowRight') this.step(rtl ? -1 : 1);
      if (e.key === 'ArrowLeft') this.step(rtl ? 1 : -1);
    }
  }
  customElements.define('ayo-reviews', AyoReviews);
}
